// src/components/Footer.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "./apiConfig";
import {
  FiFacebook,
  FiInstagram,
  FiTwitter,
  FiLinkedin,
  FiChevronRight,
  FiMapPin,
  FiPhone,
  FiMail,
  FiClock,
  FiSend,
  FiCheck
} from "react-icons/fi";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);
  const [companyData, setCompanyData] = useState({
    companyName: "HARI BALAJI TRADERS",
    companyEmail: "info@haribalaji.com"
  });

  // Fetch company data
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/Crackers/GetMinimumOrderAmount?companyId=3`);
        if (response.data.statusCode === 200 && response.data.data) {
          const data = response.data.data;
          setCompanyData({
            companyName: data.companyName || "HARI BALAJI TRADERS",
            companyEmail: data.companyEmail || "info@haribalaji.com"
          });
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
    };
    fetchCompanyData();
  }, []);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setIsSubscribed(true);
      setEmail("");
      setTimeout(() => setIsSubscribed(false), 4000);
    }
  };

  const addresses = [
    {
      name: companyData.companyName,
      address: `${companyData.companyName}, CR8Q+WV9, Sivakasi - Sattur Rd, Anuppankulam, Tamil Nadu 626189`
    },
  ];




  return (
    <footer id="contact-footer" style={footerStyle}>
      {/* Main Footer Content - 4 Columns */}
      <div style={footerContainerStyle}>
        {/* Company Info */}
        <div style={footerColumnStyle}>
          <h3 style={sectionHeadingStyle}>{companyData.companyName}</h3>
          <p style={descriptionStyle}>
            We, {companyData.companyName}, are based in Surarpatti — the Firecracker City of Tamil Nadu. We are the agency to sell all fireworks crackers based upon customer orders.
          </p>
        </div>



        {/* Contact Info */}
        <div style={footerColumnStyle}>
          <h4 style={sectionHeadingStyle}>
            <FiPhone style={{ ...headingIconStyle, color: 'white !important' }}></FiPhone>
            Contact
          </h4>

          <div style={contactDetailsStyle}>
            <div style={contactItemStyle}>
              <FiPhone style={contactIconStyle} />
              <div>
                <a href="tel:+91 9843655396" style={contactLinkStyle}>+91 9843655396</a>
                <br />
                <a href="tel:+91 9751043474" style={contactLinkStyle}>+91 9751043474</a>
              </div>
            </div>

            <div style={contactItemStyle}>
              <FiMail style={contactIconStyle} />
              <a href={`mailto:${companyData.companyEmail}`} style={contactLinkStyle}>
                {companyData.companyEmail}
              </a>
            </div>

            <div style={contactItemStyle}>
              <FiClock style={contactIconStyle} />
              <span style={contactTextStyle}>Mon - Sun: 9:00 AM - 10:00 PM</span>
            </div>
          </div>
        </div>
        {/* Address Section */}
        <div style={locationsContainerStyle}>
          <h4 style={locationsHeadingStyle}>
            <FiMapPin style={headingIconStyle} /> Our Location
          </h4>

          <div style={locationsGridStyle}>
            {addresses.map((loc, index) => (
              <div key={index} style={locationCardStyle}>
                <div style={locationHeaderStyle}>
                  <FiMapPin style={locationIconStyle} />
                  <span style={locationNameStyle}>{loc.name}</span>
                </div>

                <p style={locationAddressStyle}>{loc.address}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Map Section */}
        <div style={footerColumnStyle}>
          <h4 style={sectionHeadingStyle}>
            <FiMapPin style={headingIconStyle} />
            Get Directions
          </h4>

          <div style={compactMapContainer}>

            <a
              href="https://www.google.com/maps/place/9%C2%B025'02.2%22N+77%C2%B050'21.7%22E/@9.4172878,77.8367741,17z/data=!3m1!4b1!4m4!3m3!8m2!3d9.4172878!4d77.839349?hl=en&entry=ttu&g_ep=EgoyMDI2MDIyNC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              style={compactMapLink}
            >
              <div style={compactMapWrapper}>
                <iframe
                  title="Hari Balaji Traders Location"
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3448.3477196020712!2d77.8367741!3d9.4172878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOcKwMjUnMDIuMiJOIDc3wrA1MCcyMS43IkU!5e0!3m2!1sen!2sin!4v1714000000000!5m2!1sen!2sin"
                  style={compactMapIframe}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Locations Row - Reduced spacing */}


      <div style={bottomSectionStyle}>
        <div style={bottomContainerStyle}>


          <div style={copyrightStyle}>
            <p style={copyrightTextStyle}>
              © {new Date().getFullYear()} Hari Balaji Traders. All rights reserved.
              <br />
              <a
                href="https://vivifysoft.in/"
                target="_blank"
                rel="noopener noreferrer"
                style={developerLinkStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.textShadow = '0 0 10px rgba(255, 215, 0, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.textShadow = '0 0 5px rgba(255, 215, 0, 0.3)';
                  e.currentTarget.style.color = '#FFD700';
                }}
              >
                Developed by VivifySoft
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

// === Styles ===
const footerStyle = {
  background: '#532a51ff',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  paddingTop: '0.5rem',
};

const footerContainerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '1rem',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '2rem',
  '@media (max-width: 768px)': {
    gap: '1.5rem',
    padding: '0.5rem',
  },
  '@media (max-width: 480px)': {
    gap: '1rem',
    padding: '0.5rem 0.75rem',
  }
};

const footerColumnStyle = {
  position: 'relative',
  padding: '0 0.5rem',
  '@media (max-width: 768px)': {
    padding: '0 0.25rem',
  }
};

const sectionHeadingStyle = {
  fontSize: '1.1rem',
  fontWeight: '600',
  marginBottom: '1rem',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: 0,
  '@media (max-width: 768px)': {
    fontSize: '1rem',
    marginBottom: '0.75rem',
  }
};

const headingIconStyle = {
  fontSize: '1rem',
  '@media (max-width: 768px)': {
    fontSize: '0.9rem',
  }
};

const descriptionStyle = {
  fontSize: '0.9rem',
  lineHeight: '1.5',
  color: '#d0d0d0',
  marginBottom: '1rem',
  '@media (max-width: 768px)': {
    fontSize: '0.85rem',
    marginBottom: '0.75rem',
  }
};

const linkListStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
};

const linkItemStyle = {
  marginBottom: '0.5rem',
  '@media (max-width: 768px)': {
    marginBottom: '0.4rem',
  }
};

const linkStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  textDecoration: 'none',
  fontSize: '0.9rem',
  transition: 'all 0.3s ease',
  padding: '0.2rem 0',
  '@media (max-width: 768px)': {
    fontSize: '0.85rem',
    gap: '0.4rem',
  }
};

const chevronStyle = {
  fontSize: '0.8rem',
  color: '#FFD700',
  '@media (max-width: 768px)': {
    fontSize: '0.75rem',
  }
};

const contactDetailsStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  '@media (max-width: 768px)': {
    gap: '0.75rem',
  }
};

const contactItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.6rem',
  '@media (max-width: 768px)': {
    gap: '0.5rem',
  }
};

const contactIconStyle = {
  fontSize: '1rem',
  color: '#FFD700',
  marginTop: '2px',
  flexShrink: 0,
  '@media (max-width: 768px)': {
    fontSize: '0.9rem',
    marginTop: '3px',
  }
};

const contactLinkStyle = {
  color: '#e0e0e0',
  textDecoration: 'none',
  fontSize: '0.85rem',
  transition: 'color 0.3s ease',
  ':hover': {
    color: '#FFD700'
  },
  '@media (max-width: 768px)': {
    fontSize: '0.8rem',
  }
};

const contactTextStyle = {
  color: '#e0e0e0',
  fontSize: '0.85rem',
  '@media (max-width: 768px)': {
    fontSize: '0.8rem',
  }
};

// Map Styles
const compactMapContainer = {
  width: '85%',
  backgroundColor: 'rgba(255,255,255,0.05)',
  borderRadius: '6px',
  border: '1px solid rgba(255,255,255,0.1)',
  padding: '5px',
  marginBottom: '0.3rem',
  '@media (max-width: 768px)': {
    width: '100%',
  }
};

const compactMapHeader = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginBottom: '6px',
};

const compactMapTitle = {
  fontSize: '0.9rem',
  fontWeight: '600',
  color: '#FFD700',
  '@media (max-width: 768px)': {
    fontSize: '0.85rem',
  }
};

const compactMapLink = {
  display: 'block',
  textDecoration: 'none',
};

const compactMapWrapper = {
  position: 'relative',
  paddingBottom: '50%',
  height: 5,
  overflow: 'hidden',
  borderRadius: '4px',
};

const compactMapIframe = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  border: 'none',
};

const compactMapFooter = {
  marginTop: '6px',
  textAlign: 'center',
};

const compactMapText = {
  fontSize: '0.75rem',
  color: '#d0d0d0',
  textDecoration: 'underline',
  '@media (max-width: 768px)': {
    fontSize: '0.7rem',
  }
};

// Locations Section - Reduced spacing
const locationsContainerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '1rem 1rem 0.5rem',
  '@media (max-width: 768px)': {
    padding: '0.75rem 0.75rem 0.5rem',
  }
};

const locationsHeadingStyle = {
  fontSize: '1.1rem',
  fontWeight: '600',
  marginTop: '0',
  marginBottom: '0.8rem',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  justifyContent: 'center',
  textAlign: 'center',
  '@media (max-width: 768px)': {
    fontSize: '1rem',
    marginBottom: '0.7rem',
  }
};

const locationsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '1rem',
  '@media (max-width: 768px)': {
    gap: '0.75rem',
    gridTemplateColumns: '1fr',
  }
};

const locationCardStyle = {
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  borderRadius: '8px',
  padding: '1rem',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  ':hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
  },
  '@media (max-width: 768px)': {
    padding: '0.75rem',
  }
};

const locationHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '0.4rem',
  '@media (max-width: 768px)': {
    marginBottom: '0.3rem',
  }
};

const locationIconStyle = {
  fontSize: '0.9rem',
  color: '#FFD700',
  '@media (max-width: 768px)': {
    fontSize: '0.85rem',
  }
};

const locationNameStyle = {
  fontWeight: '600',
  color: '#FFD700',
  fontSize: '0.9rem',
  '@media (max-width: 768px)': {
    fontSize: '0.85rem',
  }
};

const locationAddressStyle = {
  fontSize: '0.8rem',
  color: '#d0d0d0',
  lineHeight: '1.4',
  margin: 0,
  whiteSpace: 'pre-line',
  '@media (max-width: 768px)': {
    fontSize: '0.75rem',
  }
};

// Bottom Section
const bottomSectionStyle = {
  background: '#6B3F69',
  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  padding: '0.8rem 0',
  '@media (max-width: 768px)': {
    padding: '0.6rem 0',
  }
};

const bottomContainerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.8rem',
  textAlign: 'center',
  '@media (max-width: 768px)': {
    padding: '0 0.75rem',
    gap: '0.6rem',
  }
};

const copyrightStyle = {
  order: 2,
};

const copyrightTextStyle = {
  margin: 0,
  fontSize: '0.8rem',
  color: '#b0b0b0',
  lineHeight: '1.4',
  '@media (max-width: 768px)': {
    fontSize: '0.75rem',
  }
};

const developerLinkStyle = {
  fontSize: '0.75rem',
  color: '#FFD700',
  fontWeight: '400',
  textDecoration: 'none',
  textShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
  transition: 'all 0.3s ease',
  '@media (max-width: 768px)': {
    fontSize: '0.7rem',
  }
};

const bottomLinksStyle = {
  order: 1,
  display: 'flex',
  alignItems: 'center',
  gap: '0.6rem',
  flexWrap: 'wrap',
  justifyContent: 'center',
  '@media (max-width: 768px)': {
    gap: '0.5rem',
  }
};

const bottomLinkStyle = {
  textDecoration: 'none',
  fontSize: '0.75rem',
  transition: 'color 0.3s ease',
  '@media (max-width: 768px)': {
    fontSize: '0.7rem',
  }
};

const separatorStyle = {
  color: '#666',
  fontSize: '0.6rem',
  '@media (max-width: 768px)': {
    fontSize: '0.55rem',
  }
};

const mapPinIconStyle = {
  color: '#FFD700',
  fontSize: '1rem',
  '@media (max-width: 768px)': {
    fontSize: '0.9rem',
  }
};

export default Footer;